import { isFeatureEnabled } from 'owa-feature-flags';
export default function isAttachmentFeatureEnabled(feature) {
    return isFeatureEnabled(feature);
}
//# sourceMappingURL=isAttachmentFeatureEnabled.js.map